import {
    SHOW_SELECTOR,
    HIDE_SELECTOR,
    TOGGLE_SELECTOR,
    SET_MANAGE_PROFILES_TEXT,
} from './constants'

const initialState = {
    open: false,
    userId: '',
    title: '',
    boundingRectangle: null,
    manageProfiles: '',
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SHOW_SELECTOR: {
            const { userId, title, boundingRectangle } = action.payload
            return {
                ...state,
                open: true,
                userId,
                title,
                boundingRectangle,
            }
        }

        case HIDE_SELECTOR: {
            return {
                ...state,
                open: false,
                userId: '',
                title: '',
                boundingRectangle: null,
            }
        }

        case TOGGLE_SELECTOR: {
            const { userId, title, boundingRectangle } = action.payload
            return {
                ...state,
                open: !state.open,
                userId: state.open ? '' : userId,
                title: state.open ? '' : title,
                boundingRectangle: state.open ? null : boundingRectangle,
            }
        }

        case SET_MANAGE_PROFILES_TEXT: {
            return {
                ...state,
                manageProfiles: action.payload,
            }
        }

        // Do nothing
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/ProfileSelector/data/reducer.js